(function ($) {
    'use strict';

    $(function () {
        function highlightMenuItem(id) {
            const inPageJumpTrigger = $('.js-in-page-jump-label');
            const inPageList = $('.js-in-page-list');

            const currentClassName = 'in-page__link--active';

            if ('undefined' !== typeof id && '' !== id) {
                const text = inPageList.find('a[href="#' + id + '"]').text();

                inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
                inPageList.find('a[href="#' + id + '"]').addClass(currentClassName);

                if (text !== '') {
                    inPageJumpTrigger.text(text);
                } else {
                    inPageJumpTrigger.text('Jump To');
                }
            }
        }

        function registerWaypoints() {
            var $section = $('[data-anchor]');

            $section.each(function () {
                var id = $(this).attr('id');

                $(this).waypoint({
                    handler: function (direction) {
                        if ('down' === direction) {
                            highlightMenuItem(id);
                        }
                    },
                });

                $(this).waypoint({
                    handler: function (direction) {
                        if ('up' === direction) {
                            highlightMenuItem(id);
                        }
                    },
                });
            });
        }

        function scrollActiveItemIntoView(activeLink) {
            const container = document.querySelector('.js-in-page-list');
            if (container && activeLink) {
                const containerRect = container.getBoundingClientRect();
                const activeLinkRect = activeLink.getBoundingClientRect();
                const offset = activeLinkRect.left - containerRect.left;
                container.scrollBy({
                    left: offset,
                    behavior: 'smooth'
                });
            }
        }

        function toggleInPageList() {
            const button = document.querySelector('.js-in-page-jump');
            const hider = document.querySelector('.js-in-page-hider');
            const links = document.querySelectorAll('.js-in-page-link');

            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                button.blur();
                hider.classList.toggle('in-page__hider--active');
            });

            links.forEach((link) => {
                link.addEventListener('click', (ev) => {
                    hider.classList.remove('in-page__hider--active');
                    scrollActiveItemIntoView(link);
                });
            });
        }

        if (document.querySelector('.js-in-page-jump')) {
            registerWaypoints();
            toggleInPageList();
        }
    });
})(jQuery);
